import { Component, Input, OnInit } from '@angular/core';
import { ApBaseComponent, ApNotificationService } from 'webcommon/core-ui';
// import { ApAlertService, ApBaseComponent, ApNotificationService } from 'webcommon/core-ui';
// import { FormControl, FormGroup, } from '@angular/forms';
// import { BrowserService, FindControlIdService, TransitionManagerService, WebCommonStorageRepository } from 'webcommon/legacy-common';
// import { FacilityVisitRepository, FpConfigurationRepository } from 'webcommon/webapi';
// import { AprimaTransitionRequest, BsDatepickerValue, FacilityPatientResultsSearchResultsDto,
// FpConfigurationDto, FpSearchParametersDto, FpUpdateUsageMetricDto } from 'webcommon/shared';

import { FacilityPatientResultsSearchResultsDto, FacilityPatientResultsSearchDto, BsDatepickerValue } from 'webcommon/shared';
import { FpResultsService } from '../services/index';
import { finalize } from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
import { FPResultsViewerModalService } from './fp-results-viewer-modal-service';

@Component({
    // providers: [ ApAlertService ],
    // styleUrls: ['./fp-results.component.less'],
    selector: 'fp-results',
    templateUrl: './fp-results.component.html',
  })
  export class FpResultsComponent extends ApBaseComponent implements OnInit {

    static readonly ajsComponentName = 'fpresults';

    @Input() patientId: string;

    constructor(
      private resultsService: FpResultsService,
      private fpResultsViewerModalService: FPResultsViewerModalService,
      private apNotificationService: ApNotificationService
      // public findControlIdService: FindControlIdService,
      // private facilityVisitRepository: FacilityVisitRepository,
      // private alertService: ApAlertService,
      // private webCommonStorageRepository: WebCommonStorageRepository,
      // private fpConfigurationRepository: FpConfigurationRepository,
      // private browserService: BrowserService
      ) {
      super();
    }

  searchResults: FacilityPatientResultsSearchResultsDto[];
  searchParameters: FacilityPatientResultsSearchDto;
  dataLoading = true;

  defaultStartDate: Date;
  selectedStartDate?: Date = undefined;
  selectedEndDate?: Date = undefined;
  startDateControl = new FormControl<BsDatepickerValue>(undefined);
  endDateControl = new FormControl<BsDatepickerValue>(undefined);

  // currentAttachmentIndex = 1;
  // currentAttachmentData: Uint8Array;

  resultsSearchFormGroup = new FormGroup({
    startDateControl: this.startDateControl,
    endDateControl: this.endDateControl,
  });

  ngOnInit(): void {
    this.setDefaultStartDate();
    this.getResults();
  }

  getResults(): void {
    this.dataLoading = true;

    const searchParameters = new FacilityPatientResultsSearchDto();
    searchParameters.PatientUid = this.patientId;
    searchParameters.SearchDateStart = this.selectedStartDate ?? this.defaultStartDate;
    searchParameters.SearchDateEnd = this.selectedEndDate ?? new Date();

    console.log('Searching for patient results'
      + '\npatientuid: ' + this.patientId
      + '\nstart date: ' + searchParameters.SearchDateStart.toDateString()
      + '\nend date: ' + searchParameters.SearchDateEnd.toDateString());

    this.resultsService.getResults(searchParameters).pipe(
      finalize(() => {
        this.dataLoading = false;
      }),
      this.takeUntilDestroy()
    ).subscribe(
      (result) => {
        this.searchResults = result;
      },
      (error: unknown) => {
        this.apNotificationService.error('An error occurred while searching for lab results.');
        throw error;
      }
    );

    console.log(this.searchResults);
  }

  setDefaultStartDate(): void {
    this.defaultStartDate = new Date();
    this.defaultStartDate.setMonth(this.defaultStartDate.getMonth() - 6);
    this.startDateControl.setValue(this.defaultStartDate);
  }

  clickedViewResults(result: FacilityPatientResultsSearchResultsDto): void {
      const isAttachment = (result.AttachmentInfos && result.AttachmentInfos.length > 0);
      const documentId = (isAttachment) ? result.AttachmentInfos[0].AttachmentUid : result.PK;

      this.fpResultsViewerModalService.openModalAsync('baseId', result, isAttachment, documentId);
    // }
  }

  clickedDownload(): void {
    console.log('@@@@ clicked download results');
  }

  onStartDateChanged(date: BsDatepickerValue) {
    this.selectedStartDate = date;
  }

  onEndDateChanged(date: BsDatepickerValue) {
    this.selectedEndDate = date;
  }
}
